export default function About(props) {
  return (
    <div id="about" className="about">
      <div className="wrapper">
        <h3>
          About Me
        </h3>
        <div className="aboutFlex">
          <div className="profilepic">
            <img src="../../assets/profilePic.webp" alt="Profile Pic" />
          </div>
          <div className="aboutDescription">
            <p className="aboutme">
            I'm a Full-Stack Developer with a proven track record of building scalable, production-grade applications using Angular, Node.js, and cloud technologies. I'm experienced in GPT-based AI integration, cloud deployment, and end-to-end project ownership. I’m a strong collaborator who thrives in fast-paced, cross-functional teams.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
} 